import React from 'react';

// Styles & Assets
import styles from './TableColCell.module.css';
import { TiArrowSortedDown, TiArrowSortedUp } from 'react-icons/ti';

// Interfaces
import { Column } from '../../../../interfaces/Columns';
import { HasID } from '../../../../interfaces/UtilInterfaces';
interface Props<T> {
    col: Column<T>,
    visible: boolean,
    isOrderAsc: boolean,
    onClick: () => void
}
export const TableColCell = <T extends HasID>({ col, visible, isOrderAsc, onClick }: Props<T>) => {

    return (
        <th className={`${col.classHeader} ${styles.headCell}`}>
            {col.sortable ?
                <button onClick={onClick} >
                    <p title={col.name()} className={`${styles.sortableColumn} ${styles.columnCell}`}>{col.name()}</p>
                    {visible ? isOrderAsc ?
                        <TiArrowSortedUp className={styles.svgArrow} role='img' data-testid='arrowUpTableCol' />
                        :
                        <TiArrowSortedDown className={styles.svgArrow} role='img' data-testid='arrowDownTableCol' />
                        :
                        <TiArrowSortedUp className={styles.hiddenArrow} role='img' />
                    }
                </button>
                :
                <p title={col.name()} className={`${styles.titleColumn} ${styles.columnCell}`}>{col.name()}</p>
            }
        </th>
    );
};